import { defineMessage } from 'services/localization';

export const messages = {
    dayOfWeekMonday: defineMessage('mo'),
    dayOfWeekTuesday: defineMessage('tu'),
    dayOfWeekWednesday: defineMessage('we'),
    dayOfWeekThursday: defineMessage('th'),
    dayOfWeekFriday: defineMessage('fr'),
    dayOfWeekSaturday: defineMessage('sa'),
    dayOfWeekSunday: defineMessage('su'),
};
